import { render } from "./ConfiguracoesUnidadePage.vue?vue&type=template&id=28eaff16"
import script from "./ConfiguracoesUnidadePage.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesUnidadePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__